import React from 'react';
import './WhyChooseUs.css';

function WhyChooseUs() {
  const features = [
    {
      id: 1,
      title: 'Expert Team',
      description: 'Certified professionals with years of experience in landscaping'
    },
    {
      id: 2,
      title: 'Quality Materials',
      description: 'Premium plants and materials for lasting, beautiful results'
    },
    {
      id: 3,
      title: 'Sustainable Practices',
      description: 'Eco-friendly solutions that benefit the environment'
    },
    {
      id: 4,
      title: 'Customer Focus',
      description: 'Dedicated support from concept to completion'
    }
  ];

  return (
    <section className="section why-choose">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Why Choose Us</span>
          <h2 className="section-title">Excellence in Every Detail</h2>
          <p className="section-subtitle">What sets Heaven Green apart from other landscaping companies</p>
        </div>
        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-item">
              <div className="feature-icon">✓</div>
              <h4 className="feature-title">{feature.title}</h4>
              <p className="feature-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;